module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'jd6shuvj',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
